import React, { useState, useEffect, useRef } from 'react';
import { Helmet } from 'react-helmet';
import "../styles/SocialSection.css";

function SocialSection() {
  const initialSocialItems = [
  // 1st and 2nd unchanged:
  {
    title: "Strength Training",
    fullEmbedCode: `<blockquote class="instagram-media" data-instgrm-permalink="https://www.instagram.com/p/DA20X6-IOkc/" data-instgrm-version="14" style="margin: 0 auto; max-width: 540px; padding: 0; border: none;"></blockquote>`,
    previewImage: "/media/social/strength-training.webp",
    loaded: false
  },
  {
    title: "Client Progress",
    fullEmbedCode: `<blockquote class="instagram-media" data-instgrm-permalink="https://www.instagram.com/reel/C8cRR1kKCkh/" data-instgrm-version="14" style="margin: 0 auto; max-width: 540px; padding: 0; border: none;"></blockquote>`,
    previewImage: "/media/social/client-progress.webp",
    loaded: false
  },

  // Start replacing from the 3rd:
  {
    title: "Motivation in Motion",  // caption/theme inferred
    fullEmbedCode: `<blockquote class="instagram-media" data-instgrm-permalink="https://www.instagram.com/p/C78nIo3sH19/" data-instgrm-version="14" style="margin: 0 auto; max-width: 540px; padding: 0; border: none;"></blockquote>`,
    previewImage: "/media/social/client-progress.webp",
    loaded: false
  },
  {
    title: "High‑energy Training Reel",
    fullEmbedCode: `<blockquote class="instagram-media" data-instgrm-permalink="https://www.instagram.com/reel/C4fBLUYKFys/" data-instgrm-version="14" style="margin: 0 auto; max-width: 540px; padding: 0; border: none;"></blockquote>`,
    previewImage: "/media/social/client-progress.webp",
    loaded: false
  },
  {
    title: "Focused Workout Highlight",
    fullEmbedCode: `<blockquote class="instagram-media" data-instgrm-permalink="https://www.instagram.com/p/C4IDVykqfrN/" data-instgrm-version="14" style="margin: 0 auto; max-width: 540px; padding: 0; border: none;"></blockquote>`,
    previewImage: "/media/social/client-progress.webp",
    loaded: false
  },
  {
    title: "Client Crush Reel",  // for reel C0yK61UKhkF
    fullEmbedCode: `<blockquote class="instagram-media" data-instgrm-permalink="https://www.instagram.com/reel/C0yK61UKhkF/" data-instgrm-version="14" style="margin: 0 auto; max-width: 540px; padding: 0; border: none;"></blockquote>`,
    previewImage: "/media/social/client-progress.webp",
    loaded: false
  }
]


  const [socialItems, setSocialItems] = useState(initialSocialItems);
  const socialRefs = useRef([]);

  useEffect(() => {
    const scriptId = 'instagram-embed-script';
    if (!document.getElementById(scriptId)) {
      const script = document.createElement('script');
      script.id = scriptId;
      script.async = true;
      script.src = "//www.instagram.com/embed.js";
      document.body.appendChild(script);
    }

    const observer = new IntersectionObserver((entries) => {
      entries.forEach((entry) => {
        if (entry.isIntersecting) {
          const idx = parseInt(entry.target.dataset.index);
          setSocialItems(prevItems => {
            const newItems = [...prevItems];
            if (!newItems[idx].loaded) {
              newItems[idx] = { ...newItems[idx], loaded: true };
              if (window.instgrm?.Embeds?.process) {
                setTimeout(() => window.instgrm.Embeds.process(), 0);
              }
            }
            return newItems;
          });
          observer.unobserve(entry.target);
        }
      });
    }, {
      rootMargin: '100px',
      threshold: 0.1
    });

    socialRefs.current.forEach(ref => {
      if (ref) observer.observe(ref);
    });

    return () => {
      socialRefs.current.forEach(ref => {
        if (ref) observer.unobserve(ref);
      });
      observer.disconnect();
    };
  }, []);

  return (
    <section id="social-section" aria-labelledby="social-heading">
      <Helmet>
        <title>Lu - Fit | Lu - Fit Personal Trainer Cape Town</title>
        <meta name="description" content="Follow Lu - Fit on Instagram to stay motivated with training clips, client stories, and fitness tips straight from Cape Town!" />
        <script type="application/ld+json">
          {JSON.stringify({
            "@context": "https://schema.org",
            "@type": "Organization",
            "name": "Lu - Fit",
            "url": "https://lu-fit.vercel.app",
            "sameAs": [
              "https://www.instagram.com/YOUR_INSTAGRAM_HANDLE"
            ]
          })}
        </script>
      </Helmet>

      <header className="social-header">
        <h2 id="social-heading">Follow Our Journey</h2>
        <p>Get daily fitness inspiration and behind-the-scenes looks into personal training sessions, client progress, and more.</p>
      </header>

      <div className="social-list-container">
        {socialItems.map((item, idx) => (
          <article
            className="social-post-card"
            key={idx}
            ref={el => socialRefs.current[idx] = el}
            data-index={idx}
            aria-label={`Instagram post: ${item.title}`}
          >
            {item.loaded ? (
              <div dangerouslySetInnerHTML={{ __html: item.fullEmbedCode }} />
              ) : (
              <img
                src={item.fullEmbedCode}
                alt={`Preview of Instagram post for ${item.title}`}
                className="social-post-placeholder"
                loading="lazy"
              />
            )}
          </article>
        ))}
      </div>
    </section>
  );
}

export default SocialSection;
